// GalleryCustom.js
import { useState } from "react";
import "../styles/gallery.css";

const GalleryCustom = () => {
  const images = [
    "/images/f1.jpg",
    "/images/f2.jpg",
    "/images/f3.jpg",
    "/images/f4.jpg",
    "/images/f5.jpg",
    "/images/f6.jpg",
    "/images/f7.jpg",
    "/images/f8.jpg",
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const prevImage = () => {
    setPhotoIndex((photoIndex + images.length - 1) % images.length);
  };

  const nextImage = () => {
    setPhotoIndex((photoIndex + 1) % images.length);
  };

  return (
    <div className="gallery-background">
      <div className="gallery-banner-title">
        <h1 className="main-title">Cần Thơ Khởi Nghiệp Đổi Mới Sáng Tạo</h1>
        <p className="sub-title">
          Thời đại công nghệ số &amp; trí tuệ nhân tạo
        </p>
      </div>
      <div className="gallery-wrapper">
        {images.map((img, idx) => (
          <div
            key={idx}
            className="gallery-item"
            onClick={() => {
              setPhotoIndex(idx);
              setIsOpen(true);
            }}
          >
            <img
              src={img}
              alt={`Gallery ${idx + 1}`}
            />
          </div>
        ))}

        {isOpen && (
          <div className="custom-lightbox">
            <div
              className="lightbox-overlay"
              onClick={() => setIsOpen(false)}
            ></div>
            <button
              className="lightbox-close"
              onClick={() => setIsOpen(false)}
            >
              ×
            </button>
            <button
              className="lightbox-prev"
              onClick={prevImage}
            >
              ‹
            </button>
            <button
              className="lightbox-next"
              onClick={nextImage}
            >
              ›
            </button>
            <img
              src={images[photoIndex]}
              alt={`Gallery ${photoIndex + 1}`}
              className="lightbox-img"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default GalleryCustom;
